import {
  LOAD_STD_LOT,
  LoadJobsiteStdLot,
  LoadJobsiteStdLotComplete,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map } from 'rxjs/operators';
import { StdLotSizeService } from '@cemex-core/cmx-api';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';

@Injectable()
export class JobsiteStdLotEffects {
  stdLotSizeLoad: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_STD_LOT),
      switchMap((action: LoadJobsiteStdLot) => {
        return this.stdLotSizeService.getMultipleStdLotSize(action.payload);
      }),
      // Api response is an array but it will always be only one
      map((response: MultipleStdLotSizeRes) => new LoadJobsiteStdLotComplete(response)),
    ),
  );

  constructor(
    private actions$: Actions,
    private stdLotSizeService: StdLotSizeService,
  ) {}
}
